import {GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiIcons} from "@leap4/frontend";
import {baseBackendRoute} from "../../../config/generals";
import React from "react";

const { MiscellaneousServices } = MuiIcons;

const fields = {name: 1, isActive: 1, external: 1}
const getParams: IGetAllParams = {fields}
let {
    store,
    columns
} = GenericItemsUtils.GenerateDefaultStoreAndColumns({baseUrl: `${baseBackendRoute}/services`}, fields,
    {isActive: {}, created: {}, name: {editLinkFunc: (id) => `/services/${id}`}, updated: {}})

const ServicesTable = () => {

    return <GenericItemsForm store={store} columns={columns} breadcrumbs={{
        link: "/services",
        text: "Services",
        icon: <MiscellaneousServices />
    }}
                             getAllParams={getParams}
                             createButton={{to: "/services/add", text: "Create Service"}}
                             tableProps={{ pageSize: 50 }}
    />
}

export {ServicesTable}